/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Amount_PrecisionInputs */

const en_case_payment_validation_amount_precision = /** @type {(inputs: Case_Payment_Validation_Amount_PrecisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use no more than two decimal places.`)
};

const pt_br2_case_payment_validation_amount_precision = /** @type {(inputs: Case_Payment_Validation_Amount_PrecisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use no máximo duas casas decimais.`)
};

/**
* | output |
* | --- |
* | "Use no more than two decimal places." |
*
* @param {Case_Payment_Validation_Amount_PrecisionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_amount_precision = /** @type {((inputs?: Case_Payment_Validation_Amount_PrecisionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Amount_PrecisionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_amount_precision(inputs)
	return pt_br2_case_payment_validation_amount_precision(inputs)
});